import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SessionState } from './session.state';

export const selectSession = createFeatureSelector<SessionState>('session');

export const selectSessionId = createSelector(selectSession, (session) => session?.id);

export const selectIsAuthorizing = createSelector(selectSession, (session) => session.authorizing);

export const selectSessionLoaded = createSelector(selectSession, (session) => !!session.loaded);
